import React from 'react';

import { Link as MuiLink, LinkProps as MuiLinkProps, styled } from '@mui/material';
import NextLink, { LinkProps as NextLinkProps } from 'next/link';

import AppColors from '~components/theme/styles/colors';

interface Props
  extends NextLinkProps,
    Omit<MuiLinkProps, 'href' | 'onMouseEnter' | 'onClick' | 'onTouchStart'> {}

export const Link = ({
  href,
  as,
  passHref = true,
  prefetch,
  replace,
  scroll,
  shallow,
  locale,
  children,
  underline = 'none',
  sx,
  ...props
}: Props) => {
  return (
    <NextLink
      href={href}
      as={as}
      passHref={passHref}
      prefetch={prefetch}
      replace={replace}
      scroll={scroll}
      shallow={shallow}
      locale={locale}
    >
      <MuiLink href="" underline={underline} sx={{ color: 'inherit', ...sx }} {...props}>
        {children}
      </MuiLink>
    </NextLink>
  );
};

export const NormalLink = styled(MuiLink)({
  color: AppColors.neutralGrey[1],
  textDecorationColor: AppColors.neutralGrey[1],
  cursor: 'pointer',

  '&:hover': {
    color: AppColors.neutralGrey[3],
    textDecorationColor: AppColors.neutralGrey[3],
  },
});

export const NormalNextLink = styled(NextLink)({
  color: AppColors.neutralGrey[1],
  textDecorationColor: AppColors.neutralGrey[1],
  cursor: 'auto',

  '&:hover': {
    color: AppColors.neutralGrey[3],
    textDecorationColor: AppColors.neutralGrey[3],
  },
});

export default Link;
